module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Italic-043cd414610a3ba77859c0287e0126a2.woff2";